<template>
  <div :class="paragraphClassList">
    <div :class="columnClassList">
      <!--
        A manual height replaces iframe-resizer, which would otherwise override
        it as soon as the embedded page loads the iframe-resizer child script.
      -->
      <iframe
        v-if="options.height"
        :src
        :style="{ height: `${options.height}px` }"
        :class="{ 'pointer-events-none': isEditing }"
        class="w-full"
      />
      <IframeResizer
        v-else
        license="GPLv3"
        :src
        :class="{ 'pointer-events-none': isEditing }"
        class="w-full"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphIframeFragment } from '#graphql-operations'

const IframeResizer = defineAsyncComponent(
  () => import('@iframe-resizer/vue/iframe-resizer.vue'),
)

const isEditing = false
const { options } = defineBlokkli({
  bundle: 'iframe',
  globalOptions: ['spacing'],
  options: {
    width: {
      type: 'radios',
      label: 'Breite',
      default: 'full',
      displayAs: 'icons',
      options: {
        full: { label: 'Volle Breite', icon: 'icon-blokkli-option-large' },
        text: { label: 'Textbreite', icon: 'icon-blokkli-option-small' },
      },
    },
    height: {
      type: 'number',
      label: 'Höhe (px)',
      nullable: true,
      min: 100,
      max: 3000,
    },
  },
})

const props = defineProps<{
  url?: ParagraphIframeFragment['url']
}>()

const paragraphClassList = computed(() => {
  const classList = [
    options.value.width === 'text' ? 'grid-container' : 'container mx-auto',
  ]

  if (options.value.spacing === 'small') {
    classList.push('py-6', 'lg:py-10')
  } else if (options.value.spacing === 'large') {
    classList.push('py-12', 'lg:py-20')
  }

  return classList
})

const columnClassList = computed(() => {
  if (options.value.width === 'text') {
    return 'col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3'
  }
  return ''
})

const src = computed(() => props.url?.uri?.path || '')
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100vh;
}
</style>
